import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen } from "react-icons/fa";
import * as CountryService from "../../../Services/Masters/Country/CountryService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const CountryComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState({});
    const [newCountryModal, setNewCountryModal] = useState(false);

    const fetchAllCountryMasterList = () => {
        CountryService.GetCountryList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setCountryList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllCountryMasterList();
        if (countryList.length > 0) {
          //console.log("Updated countryList:", countryList);
        }
    },[]);

    const onSubmit = (data) => {
      //debugger;
      if (selectedCountry?.CountryId) {
        data.CountryId = selectedCountry?.CountryId;
        CountryService.UpdateCountry(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCountryMasterList();
              toast.success("Country updated successfully!");
              handleNewCountryModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        CountryService.CreateNewCountry(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCountryMasterList();
              toast.success("Country saved successfully!");
              handleNewCountryModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewCountryModalClose = () => {
      reset();
      setSelectedCountry([]);
      setNewCountryModal(false)
    };

    const handleActivateDeActivateCountry = (rec) =>{
      CountryService.ActivateDeActivateCountry(rec.CountryId, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "Country DeActivated Successfully" : "Country Activated Successfully";
          toast.success(message);
          fetchAllCountryMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewCountryDetailById = (CountryId) => {
      //debugger;
      const selectedItem = countryList.find(item => item.CountryId === CountryId);
      if(selectedItem != null){
        setSelectedCountry(selectedItem);
        setNewCountryModal(true);
      }
      else{
        selectedCountry({});
      }
    };

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="Country List" buttonText="Add Country" onButtonClick={() => { reset(); setSelectedCountry([]); setNewCountryModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> Country</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      countryList.length > 0 ? (
                        countryList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.CountryName}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate Country" onClick={() => handleActivateDeActivateCountry(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateCountry(rec)} title="Activate Country" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewCountryDetailById(rec.CountryId)} title="Edit Country" />
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newCountryModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedCountry?.Country ? "Edit Country" : "New Country"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewCountryModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Country</label>
                              <input type="text" className="form-control" placeholder="Enter Country" {...register("CountryName", { required: "Country is required" })} defaultValue={selectedCountry?.CountryName || ""} />
                              {errors.Country && <p className="text-danger required_error">{errors.Country.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCountryModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCountry?.CountryId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default CountryComponent